import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { ApparelArticleMaster } from "../entities/tech-pack/apparel-article-master.entity";
import { FabricTrimsMaster } from "../entities/tech-pack/fabric-trims-master.entity";


@Injectable()
export class FabricTrimsMasterRepo extends Repository<FabricTrimsMaster> {

    constructor(@InjectRepository(FabricTrimsMaster) private fabricTrimsMasterRepo: Repository<FabricTrimsMaster>
    ) {
        super(fabricTrimsMasterRepo.target, fabricTrimsMasterRepo.manager, fabricTrimsMasterRepo.queryRunner);
    }

}